import { render, staticRenderFns } from "./CountSkill.vue?vue&type=template&id=9706cf1a&scoped=true"
import script from "./CountSkill.vue?vue&type=script&lang=js"
export * from "./CountSkill.vue?vue&type=script&lang=js"
import style0 from "./CountSkill.vue?vue&type=style&index=0&id=9706cf1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9706cf1a",
  null
  
)

export default component.exports